<template>
  <div class="business-settings__icon-tabs" v-if="entityType">
    <button
      v-for="category in visibleCategories"
      :key="category.key"
      type="button"
      :title="category.label"
      class="business-settings__icon-tab"
      :class="{ 'business-settings__icon-tab--active': active === category.key }"
      @click="$emit('select-category', category)"
    >
      <span class="business-settings__icon-tab-badge" :style="{ backgroundColor: category.iconBg }">
        <v-icon size="22" :color="category.iconColor" class="business-settings__icon-tab-icon">{{ category.icon }}</v-icon>
      </span>
      <span class="business-settings__icon-tab-label">{{ category.shortLabel }}</span>
    </button>
  </div>
</template>

<script>
import { CATEGORY_CONFIG } from './categories'

export default {
  name: 'CategoryList',
  props: {
    entityType: { type: String, default: null },
    warehouseModuleActive: { type: Boolean, default: false },
    selectionKey: { type: [String, Number], default: null }
  },
  data () {
    return { active: null }
  },
  computed: {
    visibleCategories () {
      if (!this.entityType) return []
      return (CATEGORY_CONFIG[this.entityType] || [])
        .filter(c => !c.requiresWarehouseModule || this.warehouseModuleActive)
    }
  },
  watch: {
    visibleCategories () {
      this.selectFirstCategory()
    },
    selectionKey () {
      this.selectFirstCategory()
    }
  },
  methods: {
    select (category) {
      this.active = category.key
    },
    selectFirstCategory () {
      const categories = this.visibleCategories
      if (categories.length) {
        this.active = categories[0].key
        this.$emit('select-category', categories[0])
      } else {
        this.active = null
      }
    }
  },
  created () {
    this.$on('select-category', this.select)
  },
  mounted () {
    this.selectFirstCategory()
  }
}
</script>

<style scoped>
.business-settings__icon-tabs {
  display: flex;
  flex-direction: column;
  padding: 10px 10px;
  gap: 6px;
}
.business-settings__icon-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 8px 4px;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  gap: 4px;
  transition: all 0.2s ease;
}
.business-settings__icon-tab-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  box-shadow:
    0 2px 8px rgba(0, 0, 0, 0.12),
    inset 0 1px 1px rgba(255, 255, 255, 0.5),
    inset 0 -1px 1px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), filter 0.3s ease;
}
.business-settings__icon-tab:not(.business-settings__icon-tab--active):hover {
  background-color: rgba(243, 244, 246, 0.8);
  transition: background-color 0.2s ease;
}
.business-settings__icon-tab-icon {
  transition: filter 0.2s ease;
}
.business-settings__icon-tab-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #475569;
  text-align: center;
  line-height: 1.2;
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.business-settings__icon-tab:hover .business-settings__icon-tab-badge {
  transform: translateY(-3px) scale(1.05);
  filter: brightness(1.15) saturate(1.1);
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.25),
    0 4px 12px rgba(0, 0, 0, 0.15),
    inset 0 1px 2px rgba(255, 255, 255, 0.5),
    inset 0 -1px 2px rgba(0, 0, 0, 0.1);
}
.business-settings__icon-tab:hover .business-settings__icon-tab-label {
  opacity: 1;
  transform: translateY(-1px);
  text-shadow: 0 2px 8px rgba(0, 179, 190, 0.4);
  font-weight: 700;
  letter-spacing: 0.06em;
}
.business-settings__icon-tab--active .business-settings__icon-tab-badge {
  filter: brightness(1.2) saturate(1.2);
  box-shadow:
    0 4px 16px rgba(0, 0, 0, 0.3),
    0 2px 8px rgba(0, 0, 0, 0.2),
    inset 0 1px 1px rgba(255, 255, 255, 0.3);
}
.business-settings__icon-tab--active .business-settings__icon-tab-label {
  opacity: 1;
  font-weight: 700;
  color: #00838F;
  text-shadow: 0 2px 12px rgba(97, 84, 164, 0.35);
  letter-spacing: 0.06em;
}
</style>
